module.exports = {
	mapbox: {
		token: process.env.VUE_APP_MAPBOX_TOKEN || null,
		custom_map_url: process.env.VUE_APP_CUSTOM_MAP_URL || null,
		satellite_map_url: process.env.VUE_APP_SATELLITE_MAP_URL || null
	},
	max_hours_update: process.env.VUE_APP_MAX_FORECAST_HOURS_UPDATE || 24,
	max_locations: process.env.VUE_APP_MAX_LOCATIONS || 50,
	api_url: process.env.VUE_APP_API_URL || null
};
